import { render, staticRenderFns } from "./UrlsTable.vue?vue&type=template&id=659c197c&scoped=true&"
import script from "./UrlsTable.vue?vue&type=script&lang=js&"
export * from "./UrlsTable.vue?vue&type=script&lang=js&"
import style0 from "./UrlsTable.vue?vue&type=style&index=0&id=659c197c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659c197c",
  null
  
)

export default component.exports